export class SupportFinancial {
  supportFinancialClassIds: number[] = [];
  percentNeedsMet = null;
  noPreferenceNeedsMet = null;
  tuitionFees = null;
  noPreferenceTuition = null;
  studentStateId = null;
}
